// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"24":"c4ab3ff6","58":"6dafc4dc","79":"7606b59c","158":"ae39ba33","250":"118a1ced","372":"73d2eb9d","446":"7dab8617","504":"576aab23","702":"7dbf31bc","795":"bf0574d7","879":"43e0cdd1","917":"9701fcdd","934":"c055abb6","947":"d74b8a12"}[chunkId] + ".chunk.js";
};